import { useFormEditor } from "../../../../../../hooks/checklist-hooks";
import ChecklistTextInputBuilder from "./ChecklistTextInputBuilder";

interface Props {
  className?: string;
  closeForm: () => void;
}

const ChecklistTextInputCreator = (props: Props) => {
  const ctx = useFormEditor();

  return (
    <ChecklistTextInputBuilder
      closeForm={props.closeForm}
      onSubmit={(values) => {
        ctx.controls.addElement({ element: values });
        props.closeForm();
      }}
    />
  );
};

export default ChecklistTextInputCreator;
